import React, { useState, useEffect, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import "./StartCommunities.css";
import PolygonMap from "../../../Moderator/EditCommunity/Polygon";
import StartMap from "../../../../Components/DefaultCommunity/startMap";
import axios from "axios";
import * as Cookies from "js-cookie";
import { Dialog, Button, DialogTitle, IconButton } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import Popup from "reactjs-popup";
import CancelIcon from "@mui/icons-material/Cancel";
import CommunityImage from "src/Assets/images/ComImage.svg";
import MapIcon from "src/Assets/images/MapIcon.svg";
import Camera from "src/Assets/images/camera.svg";
import CloseBtn from "src/Assets/images/CloseButton.svg";
import API from "../../../../network";
import { compressFile } from "src/Utils/imageCompressionUtil";
import { emailRegex } from "src/Constants/regex";
import countryDialCodeData from "src/Constants/CountryDialCodes.json";
import { BsInfoCircle } from "react-icons/bs";
import { Popover, Typography } from "@material-ui/core";
import Select from "react-select";

const useStyles = makeStyles({
  paperWidthSm: {
    padding: "20px 15px 15px 15px",
    borderRadius: "25px",
    width: "800px",
    maxWidth: "800px",
    height: "500px",
    overflow: "hidden",
    maxWidth: "800px !important",
  },
});

const selectStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    borderColor: "red",
    width: "100%",
    borderRadius: "50px",
    border: "1px solid #707070",
    fontSize: "16px",
    color: "grey",
  }),
};

function StartCommunities(props) {
  const { allCommunities, hasCountryCommunity } = props;
  const classes = useStyles();
  const [communityData, setcommunityData] = useState({});
  const [communities, setCommunities] = useState([]);
  const [error, setError] = useState(null);
  const [communityAlreadyExist, setCommunityAlreadyExist] = useState(false);
  const [communityCheckStatus, setCommunityCheckStatus] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const displayNameOpen = Boolean(anchorEl);
  const [countryDialCode, setCountryDialCode] = useState("");
  const displayNameId = displayNameOpen
    ? "display-name-info-popover"
    : undefined;

  // Function to fetch nearby communities
  const fetchNearbyCommunities = async () => {
    try {
      const response = await API.getNearByUserCommunities();
      setCommunities(response.data.physicalTenantList);
    } catch (err) {
      console.error("Failed to fetch communities:", err);
      setError("Unable to load Communities");
    }
  };

  useEffect(() => {
    console.log(`error in tenant map`);
    fetchNearbyCommunities();
  }, []);

  useEffect(() => {
    API.getCommunity()
      .then((res) => {
        setcommunityData(res.data);
        const userContactDetails = extractPhoneDetails(res.data?.user?.phone);
        console.log(`userContactDetails:`, userContactDetails);
        const iso2FromBackend = res.data?.user?.phoneIso2Code;
        const userCountryCodeAndNameData = countryDialCodeData.find((item) =>
          iso2FromBackend
            ? item.iso2 === iso2FromBackend
            : item.dialCode === userContactDetails?.code,
        );
        if (userCountryCodeAndNameData) {
          const val = `${userCountryCodeAndNameData?.dialCode}-${userCountryCodeAndNameData?.iso2}`;
          setCountryDialCode(val);
        } else {
          setCountryDialCode("");
        }
      })
      .catch((err) => {
        console.error("Failed to fetch community data:", err);
      });
  }, []);

  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const [closeW, setCloseW] = useState(false);
  const [nameErrorMsg, setNameErrorMsg] = useState(false);
  const [descriptionErrorMsg, setDescriptionErrorMsg] = useState(false);
  const [countryErrorMsg, setCountryErrorMsg] = useState(false);
  const [addressErrorMsg, setAddressErrorMsg] = useState(false);
  const [cityErrorMsg, setCityErrorMsg] = useState(false);
  const [stateErrorMsg, setStateErrorMsg] = useState(false);
  const [zipCodeErrorMsg, setZipCodeErrorMsg] = useState(false);
  const [submitErrMsg, setSubmitErrMsg] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [tenantAddress, setTenantAddress] = useState("");
  const [tenantCity, setTenantCity] = useState("");
  const [tenantZipcode, setTenantZipcode] = useState("");
  const [tenantCountry, setTenantCountry] = useState("");
  const [tenantStateList, setTenantStateList] = useState([]);
  const [tenantState, setTenantState] = useState("");
  const [tenantLat, setTenantLat] = useState("");
  const [tenantLng, setTenantLng] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [statesList, setStateList] = useState([]);
  const [communityType, setCommunityType] = useState("public");
  const [communityView, setCommunityView] = useState("view");
  const [emailID, setEmailID] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phonenum, setPhonenum] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  // const [logo, setLogo] = useState("");
  const [userGuidelineChecked, setUserGuidelineChecked] = useState(false);
  const [modGuidelineChecked, setModGuidelineChecked] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [responseData, setResponseData] = useState({});
  const [file, setFile] = useState();
  const [picImageFile, setPicImageFile] = useState(null);
  const [mapErrorMessage, setMapErrorMessage] = useState("");
  const [currentCommunityLocation, setCurrentCommunityLocation] = useState({
    lat: 20.5937,
    lng: 78.9629, // Default to India
  });
  const [zoomLevel, setZoomLevel] = useState(5); // Default zoom for country-level
  const [emailExistsModal, setEmailExistsModal] = useState(false);
  const [existingEmail, setExistingEmail] = useState("");

  const history = useHistory();

  const userDetails = useSelector((state) => state.SignInReducer.userDetails);

  const isDefaultCommBlocked =
    userDetails?.userData?.communityStatus === "communityBlocked";
  const signinOrBlocked = props?.signIn || isDefaultCommBlocked;

  useEffect(() => {
    const phone = communityData?.user?.phone || ""; // "+55 9846372355"
    const iso2FromBackend = communityData?.user?.phoneIso2Code;
    const [countryCode, phoneNumber] = phone.split(" ");

    setEmailID(communityData?.user?.email);
    setDisplayName(communityData?.user?.displayName);
    setFirstname(communityData?.user?.firstName);
    setLastname(communityData?.user?.lastName);
    setPhonenum(phoneNumber);
    setAddress(communityData?.user?.address);
    setCity(communityData?.user?.address2);
    setZipcode(communityData?.user?.zipcode);
    setCountry(communityData?.country);
    setState(communityData?.state);

    const userCountryCodeAndNameData = countryDialCodeData.find((item) =>
      iso2FromBackend
        ? item.iso2 === iso2FromBackend
        : item.dialCode === countryCode,
    );
    if (userCountryCodeAndNameData) {
      const val = `${userCountryCodeAndNameData?.dialCode}-${userCountryCodeAndNameData?.iso2}`;
      setCountryDialCode(val);
    } else {
      setCountryDialCode("");
    }
  }, [communityData?.user, communityData]);

  const hasProfileDisplayName = Boolean(
    communityData?.user?.displayName &&
      communityData?.user?.displayName.trim() !== "",
  );
  const hasProfileEmail = Boolean(
    communityData?.user?.email && communityData?.user?.email.trim() !== "",
  );
  const hasProfileFirstName = Boolean(
    communityData?.user?.firstName &&
      communityData?.user?.firstName.trim() !== "",
  );
  const hasProfileLastName = Boolean(
    communityData?.user?.lastName &&
      communityData?.user?.lastName.trim() !== "",
  );

  const initialPhoneStr = communityData?.user?.phone || "";
  const [, profilePhoneNumber] = initialPhoneStr.split(" ");
  const hasProfilePhone = Boolean(
    profilePhoneNumber && profilePhoneNumber.trim() !== "",
  );

  const hasProfileCountry = Boolean(
    (communityData?.country || communityData?.user?.country) &&
      (communityData?.country || communityData?.user?.country).trim() !== "",
  );
  const hasProfileAddress = Boolean(
    communityData?.user?.address &&
      communityData?.user?.address.trim() !== "",
  );
  const hasProfileCity = Boolean(
    (communityData?.user?.address2 || communityData?.user?.city) &&
      (communityData?.user?.address2 || communityData?.user?.city).trim() !==
        "",
  );
  const hasProfileState = Boolean(
    (communityData?.state || communityData?.user?.state) &&
      (communityData?.state || communityData?.user?.state).trim() !== "",
  );
  const hasProfileZipcode = Boolean(
    communityData?.user?.zipcode &&
      communityData?.user?.zipcode.trim() !== "",
  );

  const handleEmailBlur = async () => {
    if (!signinOrBlocked && emailID && emailRegex.test(emailID)) {
      try {
        const emailFormData = new FormData();
        emailFormData.append("mail", emailID);

        const emailRes = await API.verifyEmail(emailFormData);
        const emailStatus = emailRes?.data?.status;

        if (emailStatus === "SkopicUser") {
          setExistingEmail(emailID);
          setEmailExistsModal(true);
        }
      } catch (err) {
        console.error("Error verifying email:", err);
      }
    }
  };

  //   useEffect(() => {
  //     axios
  //       .request({
  //           url: `https://dev.skopic.com/skopicportal/jsonuser/tenant-map?mapStatus=IndexNear&requestCommunity=requestCommunity`,
  //         // url: `https://dev.skopic.com/skopicportal/jsonuser/tenant-list`,
  //         method: "Get",
  //         headers: {
  //           "Access-Control-Allow-Origin": "*",
  //           "Set-Cookie": Cookies.get("JSESSIONID"),
  //         },
  //         withCredentials: true,
  //       })
  //       .then((res) => {
  //         const obj = { country_code: "", latitude: "", country_name: "Select" };
  //         const data = res.data.countryList;
  //         data.unshift(obj);
  //         setCountryList(data);
  //       });
  //   }, []);
  //   example of state code written here

  useEffect(() => {
    API.getTenantList().then((res) => {
      if (res) {
        let countryArray = [];
        if (res && Object.keys(res.data.statesList).length !== 0) {
          setResponseData(res.data.statesList);
          Object.keys(res.data.statesList).map((country) => {
            countryArray.push(country);
          });
          setCountryList(countryArray);
        }
      }
    });
  }, []);

  useEffect(() => {
    if (country && responseData[country]) {
      updateStateList({ label: country, value: country });
    }
  }, [country, responseData]);

  useEffect(() => {
    if (
      communityData?.state &&
      statesList.length > 0 &&
      statesList.includes(communityData.state)
    ) {
      setState(communityData.state);
    }
  }, [statesList, communityData?.state]);

  useEffect(() => {
    const defaultCountryName = props?.defaultCountryName;
    if (defaultCountryName && responseData) {
      setTenantCountry(defaultCountryName);
      if (Object.keys(responseData).includes(defaultCountryName)) {
        setTenantStateList(responseData[defaultCountryName]);
      }
    }
  }, [responseData, props?.defaultCountryName]);

  useEffect(() => {
    const trimmedName = name.trim();

    const fetchCommunityStatus = async () => {
      try {
        const formData = new FormData();
        formData.append("commuName", trimmedName);
        formData.append("flag", "startCommunity");

        const response = await API.communityCheck(formData);
        setCommunityCheckStatus(response?.data?.status);
      } catch (err) {
        console.error("API error:", err);
      }
    };

    fetchCommunityStatus();

    const communityList = communities ?? allCommunities; // Use communities or fallback to allCommunities

    const exists = communityList?.some(
      (item) => item.trim().toLowerCase() === trimmedName.toLowerCase(),
    );

    setCommunityAlreadyExist(exists);
  }, [communities, allCommunities, name]);

  function extractPhoneDetails(phone) {
    if (!phone) return null;

    // Remove all characters except +, digits, and spaces
    const cleaned = phone.replace(/[^\d+ ]/g, "").trim();

    // Match country code (starts with + and followed by digits)
    const match = cleaned.match(/^(\+?\d+)\s*(\d+)$/);

    if (!match || match.length < 3) return null;

    const code = match[1]; // e.g., "+86"
    const fullNumber = match[2]; // e.g., "6577886656"

    // Take the last 10 digits as phone number
    const number = fullNumber.slice(-10);

    // Validate it's exactly 10 digits
    if (!/^\d{10}$/.test(number)) return null;

    return { code, number };
  }

  // useEffect(() => {
  //   const userContactDetails = extractPhoneDetails(phonenum)
  //   const countryCodeDetail = countryDialCodeData
  //   console.log(`countryCode:`, countryDialCodeData);
  //   console.log(`userContactDetails:`, userContactDetails);
  //   if (props?.defaultCountryDialCode && props?.defaultCountryName) {
  //     const val = `${props?.defaultCountryDialCode}${props?.defaultCountryName}`;
  //     setCountryDialCode(val);
  //   } else {
  //     setCountryDialCode("+1USA");
  //   }
  // }, [props?.defaultCountryDialCode, props?.defaultCountryName]);

  const onCountryDialCodeChange = (e) => {
    setCountryDialCode(e.target.value);
  };

  const updateStateList = (selectedCountry) => {
    const selectedCountryName = selectedCountry?.value || "";
    // setTenantCountry(selectedCountryName);
    setCountry(selectedCountryName);
    setState("");
    setCountryErrorMsg(false);
    if (Object.keys(responseData).includes(selectedCountryName)) {
      setStateList(responseData[selectedCountryName]);
    }
  };
  const updateCommunityStateList = (selectedCountry) => {
    const selectedCountryName = selectedCountry?.value || "";
    setTenantCountry(selectedCountryName);
    setTenantState("");
    setCountryErrorMsg(false);
    setMapErrorMessage("");
    if (Object.keys(responseData).includes(selectedCountryName)) {
      setTenantStateList(responseData[selectedCountryName]);
    }
  };

  //   example of state code written ends here

  const getLatLng = (data) => {
    if (data && Object.keys(data).length > 0) {
      setTenantLat(data.lat.toString());
      setTenantLng(data.lng.toString());
    }
  };

  useEffect(() => {
    const updateLocation = async () => {
      if (tenantCountry && tenantState) {
        const location = await getStateLatLng(tenantCountry, tenantState);
        if (location) {
          setCurrentCommunityLocation(location);
          setZoomLevel(8); // Adjust zoom for state level
        }
      } else if (tenantCountry) {
        const location = await getCountryLatLng(tenantCountry);
        if (location) {
          setCurrentCommunityLocation(location);
          setZoomLevel(5); // Zoom out to country level
        }
      } else {
        // Default to India
        setCurrentCommunityLocation({ lat: 20.5937, lng: 78.9629 });
        setZoomLevel(5);
      }
    };

    updateLocation();
  }, [tenantCountry, tenantState]);

  // Function to fetch state coordinates
  const getStateLatLng = async (countryName, stateName) => {
    try {
      const query = `${stateName}, ${countryName}`;
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?q=${query}&format=json&addressdetails=1`,
      );
      const data = await response.json();

      if (data && data.length > 0) {
        return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
      } else {
        console.warn(`Coordinates not found for ${stateName}, ${countryName}`);
        return null;
      }
    } catch (error) {
      console.error("Error fetching state coordinates:", error);
      return null;
    }
  };

  // Function to fetch country coordinates
  const getCountryLatLng = async (countryName) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?country=${countryName}&format=json`,
      );
      const data = await response.json();

      if (data && data.length > 0) {
        return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
      } else {
        console.warn(`Coordinates not found for ${countryName}`);
        return null;
      }
    } catch (error) {
      console.error("Error fetching country coordinates:", error);
      return null;
    }
  };

  const OpenModalHandler = () => {
    if (communityAlreadyExist) {
      alert(
        "This Community already exists. Please Enter a different Community name.",
      );
      return;
    }
    // Checking if all required fields are filled
    if (
      name !== "" &&
      description !== "" &&
      tenantCountry !== "" &&
      tenantAddress !== "" &&
      tenantCity !== "" &&
      tenantState !== "" &&
      tenantZipcode !== ""
    ) {
      // If all fields are filled, setting open state to true
      setOpen(true);
      setCloseW(true);
    } else {
      // If any required field is empty, displaying error messages
      if (name === "") {
        setNameErrorMsg(true);
      }
      if (description === "") {
        setDescriptionErrorMsg(true);
      }
      if (tenantCountry === "") {
        setCountryErrorMsg(true);
      }
      if (tenantAddress === "") {
        setAddressErrorMsg(true);
      }
      if (tenantCity === "") {
        setCityErrorMsg(true);
      }
      if (tenantState === "") {
        setStateErrorMsg(true);
      }
      if (tenantZipcode === "") {
        setZipCodeErrorMsg(true);
      }
    }
  };

  const mapCommunity = () => {
    if (!tenantCountry && !tenantState) {
      setMapErrorMessage("Please select the Country and State");
    } else if (!tenantCountry) {
      setMapErrorMessage("Please select the Country");
    } else if (!tenantState) {
      setMapErrorMessage("Please select the State");
    } else {
      setMapErrorMessage(""); // Clear error message if everything is valid
      setIsOpen(true);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  let className = "Second";
  if (open) {
    className = "Second--active";
  }

  let block = "StartCommunity-Container";
  if (closeW) {
    block = "StartCommunity-ContainerNone";
  }

  const handleChange = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      const compressedFile = await compressFile(file); //compress file
      const photoUrl = URL.createObjectURL(compressedFile);
      setFile(photoUrl);
      setPicImageFile(compressedFile);
    }
  };

  // const handleChange = (e) => {
  //   e.preventDefault();
  //   const selectedFile = e.target.files[0];
  //   const photoUrl = URL.createObjectURL(e.target.files[0])
  //   setFile(photoUrl); // Update file state with the selected file
  // };

  const startCommunity = async () => {
    const [dialCode, iso2] = countryDialCode.split("-"); // e.g. "+91-IN" → ["+91", "IN"]
    const fullPhoneNumber = `${dialCode} ${phonenum}`;
    if (
      emailRegex.test(emailID) &&
      displayName !== "" &&
      firstname !== "" &&
      lastname !== "" &&
      phonenum !== "" &&
      phonenum?.length === 10 &&
      countryDialCode !== "" &&
      address !== "" &&
      city !== "" &&
      zipcode !== "" &&
      state !== "" &&
      userGuidelineChecked === true &&
      modGuidelineChecked === true
    ) {
      try {
        if (!props?.signIn) {
          const emailFormData = new FormData();
          emailFormData.append("mail", emailID);

          const emailRes = await API.verifyEmail(emailFormData);
          const emailStatus = emailRes?.data?.status;

          if (emailStatus === "SkopicUser") {
            setExistingEmail(emailID);
            setEmailExistsModal(true);
            return;
          }
        }

        let data = new FormData();
        data.append("modirate", "Y");
        data.append("communityView", communityView);
        data.append("name", name);
        data.append("description", description);
        data.append("tenantAddress", tenantAddress);
        data.append("tenantCity", tenantCity);
        data.append("tenantZipcode", tenantZipcode);
        data.append("communityType", communityType);
        data.append("tenantLatitude", tenantLat);
        data.append("tenantLangitude", tenantLng);
        data.append("tenantCountry", tenantCountry);
        data.append("tenantState", tenantState);
        data.append("emailID", emailID);
        data.append("displayName", displayName);
        data.append("firstname", firstname);
        data.append("lastname", lastname);
        data.append("phonenum", fullPhoneNumber);
        data.append("phoneIso2Code", iso2 || ""); // e.g. "IN", "CA", "US"
        data.append("city", city);
        data.append("address", address);
        data.append("zipcode", zipcode);
        data.append("state", state);
        if (picImageFile) {
          data.append("img", picImageFile);
        }

        const res = await API.createNewCommunity(data);
        if (res.data.status === "Success") {
          setSubmitStatus(true);
          setSuccessMsg(res.data.message);
        }
      } catch (error) {
        console.error(error);
        if (!emailExistsModal) {
          alert("Something went wrong. Please try again.");
        }
      }
    } else {
      setSubmitErrMsg(true);
    }
  };

  const onClickDisplayNameInfo = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const onHideDisplayNameInfo = () => {
    setAnchorEl(null);
  };

  const initialPhoneNumber = communityData?.user?.phone || "";
  const [, phoneNumber] = initialPhoneNumber.split(" "); // ignore country code
  const hasPhoneNumber = Boolean(phoneNumber);

  return (
    <div style={{ zIndex: 1500 }}>
      {communityData && Object.keys(communityData).length !== 0 ? (
        <>
          <div className="StartCommunityFirstPage">
            <div className={block}>
              <div className="StartCommunity-Header">
                <p className="StartCommunity-Header--Title">
                  {!hasCountryCommunity
                    ? `Start your Community${
                        tenantCountry ? ` in ${tenantCountry}` : ""
                      }`
                    : `Start your Community`}
                </p>
                <button
                  className="StartCommunity-Header--Close"
                  onClick={props.close}
                >
                  <img src={CloseBtn} alt="Close-Button" />
                </button>
              </div>
              <div className="StartCommunity-Body">
                <div className="StartCommunity-Info">
                  <span className="indicatorImportant">*</span>&nbsp;Indicates
                  required
                </div>
                <div className="StartCommunity-Body--Intialinfo">
                  <div className="StartCommunity-Body--CommunityImage">
                    <p>Community Picture:</p>
                    <div className="StartCommunity-CommunityImage">
                      <img
                        src={file !== undefined ? file : CommunityImage}
                        alt="Community-Image"
                      />
                      <label className="Camera-Icon">
                        <input
                          type="file"
                          name="file"
                          accept="image/*"
                          capture="environment"
                          style={{ display: "none" }}
                          onChange={handleChange}
                        />
                        <img src={Camera} alt="Camera" />
                      </label>
                      {/* <button className="Camera-Icon">
                        <img src={Camera} alt="Camera" />
                      </button> */}
                    </div>
                  </div>
                  <div className="StartCommunity-Body--CommunityType">
                    <p>
                      Community Type:{" "}
                      <span className="indicatorImportant">*</span>
                    </p>
                    <div className="StartCommunity-CommunityOptions">
                      <div>
                        <input
                          type="radio"
                          name="communityType"
                          value={communityType}
                          checked={communityType === "public"}
                          onChange={() => setCommunityType("public")}
                        />
                        <p>
                          Public <br />
                          <span>Community accessible to all members</span>
                        </p>
                      </div>
                      <div>
                        <input
                          type="radio"
                          name="communityType"
                          value={communityType}
                          onChange={() => {
                            setCommunityType("private");
                            setCommunityView("view");
                          }}
                        />
                        <p>
                          Private <br />
                          <span>
                            Members join Community by invitation or by request
                          </span>
                        </p>
                      </div>
                    </div>
                    {communityType === "private" ? (
                      <div className="StartCommunity-PrivateCommunityOptions">
                        <div>
                          <input
                            type="radio"
                            name="communityView"
                            value={communityView}
                            checked={communityView === "view"}
                            onChange={() => setCommunityView("view")}
                          />
                          <p>
                            View Only <br />
                            <span>
                              Non members can view all activity and content
                            </span>
                          </p>
                        </div>
                        <div>
                          <input
                            type="radio"
                            name="communityView"
                            value={communityView}
                            onChange={() => setCommunityView("hide")}
                          />
                          <p>
                            Hide <br />
                            <span>Community hidden from all non members</span>
                          </p>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="StartCommunity-Body--CommunityForm">
                  <div className="EditInputfeild">
                    <label className="EditName">
                      Community Name:
                      <span className="indicatorImportant">*</span>
                    </label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        // Clear the error message when the user starts typing
                        setNameErrorMsg(false);
                      }}
                      maxLength={50}
                    />
                    {nameErrorMsg ? (
                      <p id="name" className="StartCommunityErrorMsg">
                        Please Enter Name
                      </p>
                    ) : null}
                    {(communities?.length > 0 || allCommunities?.length > 0) &&
                    name.trim() !== "" ? (
                      communityAlreadyExist ? (
                        <p style={{ color: "red", fontSize: "15px" }}>
                          This Community already exists
                        </p>
                      ) : (
                        communityCheckStatus !==
                          "This community doesn't exist" && (
                          <p style={{ color: "blue", fontSize: "15px" }}>
                            {communityCheckStatus}
                          </p>
                        )
                      )
                    ) : null}
                  </div>

                  <label className="EditNameDesc">
                    Description:<span className="indicatorImportant">*</span>
                  </label>
                  <textarea
                    className="EditTextfeild"
                    value={description}
                    onChange={(e) => {
                      setDescription(e.target.value);
                      setDescriptionErrorMsg(false);
                    }}
                    maxLength={140}
                  ></textarea>
                  {descriptionErrorMsg ? (
                    <p id="" className="StartCommunityErrorMsg">
                      Please Enter Description
                    </p>
                  ) : null}

                  <div className="EditInputfeild">
                    <label className="EditName">
                      Country:<span className="indicatorImportant">*</span>
                    </label>
                    <Select
                      options={countryList.map((ele) => ({
                        label: ele,
                        value: ele,
                      }))}
                      value={{ label: tenantCountry, value: tenantCountry }}
                      onChange={(selected) =>
                        updateCommunityStateList(selected)
                      }
                      styles={selectStyles}
                    />
                    {countryErrorMsg ? (
                      <p id="name" className="StartCommunityErrorMsg">
                        Please Enter Country
                      </p>
                    ) : null}
                  </div>
                  <div className="address-city-input-main-container">
                    <div className="EditInputSubfeild">
                      <label className="EditName">
                        Address:<span className="indicatorImportant">*</span>
                      </label>
                      <input
                        type="text"
                        value={tenantAddress}
                        onChange={(e) => {
                          setTenantAddress(e.target.value);
                          setAddressErrorMsg(false);
                        }}
                        maxLength={50}
                      />
                      {addressErrorMsg ? (
                        <p id="name" className="StartCommunityErrorMsg">
                          Please Enter Address
                        </p>
                      ) : null}
                    </div>

                    <div className="EditInputSubfeild">
                      <label className="EditName">
                        City:<span className="indicatorImportant">*</span>
                      </label>
                      <input
                        type="text"
                        value={tenantCity}
                        onChange={(e) => {
                          setTenantCity(e.target.value);
                          setCityErrorMsg(false);
                        }}
                        maxLength={50}
                      />
                      {cityErrorMsg ? (
                        <p id="name" className="StartCommunityErrorMsg">
                          Please Enter City
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="address-city-input-main-container">
                    <div className="EditInputSubfeild">
                      <label className="EditName">
                        State:<span className="indicatorImportant">*</span>
                      </label>
                      <Select
                        options={
                          tenantStateList
                            ? tenantStateList.map((ele) => ({
                                label: ele,
                                value: ele,
                              }))
                            : []
                        }
                        value={{ label: tenantState, value: tenantState }}
                        onChange={(selected) => {
                          const tntState = selected?.value || "";
                          setTenantState(tntState);
                          setStateErrorMsg(false);
                          setMapErrorMessage("");
                        }}
                        styles={selectStyles}
                      />
                      {stateErrorMsg ? (
                        <p id="name" className="StartCommunityErrorMsg">
                          Please Enter State
                        </p>
                      ) : null}
                    </div>

                    <div className="EditInputSubfeild">
                      <label className="EditName">
                        Zip Code:<span className="indicatorImportant">*</span>
                      </label>
                      <input
                        type="text"
                        value={tenantZipcode}
                        onChange={(e) => {
                          setTenantZipcode(e.target.value);
                          setZipCodeErrorMsg(false);
                        }}
                        maxLength={15}
                        // onKeyPress={(event) => {
                        //   if (!/[0-9]/.test(event.key)) {
                        //     event.preventDefault();
                        //   }
                        // }}
                      />
                      {zipCodeErrorMsg ? (
                        <p id="name" className="StartCommunityErrorMsg">
                          Please Enter Zip Code
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className="StartCommunity-Footer">
                <div style={{ marginLeft: "20px" }}>
                  <Button
                    variant="text"
                    onClick={mapCommunity}
                    sx={{ textTransform: "none" }}
                  >
                    <img src={MapIcon} alt="Map-Icon" />
                    &nbsp; Map Community
                  </Button>
                  {mapErrorMessage && (
                    <p className="StartCommunityErrorMsg">{mapErrorMessage}</p>
                  )}
                </div>
                <div className="SubmitPageContainer">
                  <button
                    onClick={OpenModalHandler}
                    className={
                      name !== "" &&
                      description !== "" &&
                      tenantCountry !== "" &&
                      tenantAddress !== "" &&
                      tenantCity !== "" &&
                      tenantState !== "" &&
                      tenantZipcode !== ""
                        ? "afterSubmitFirstPage"
                        : "beforeSubmitFirstPage"
                    }
                  >
                    Submit
                  </button>
                  <span>1 of 2</span>
                </div>
                {isOpen ? (
                  <Dialog
                    open={isOpen}
                    onClose={handleClose}
                    classes={{ paperWidthSm: classes.paperWidthSm }}
                    sx={{
                      zIndex: 1900,
                    }}
                  >
                    <DialogTitle
                      disableTypography
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      sx={{ padding: 0 }}
                    >
                      <h5>Map Community</h5>
                      <IconButton onClick={handleClose}>
                        <CancelIcon />
                      </IconButton>
                    </DialogTitle>
                    <StartMap
                      onMapClose={handleClose}
                      getLatLng={getLatLng}
                      tenantLatitude={tenantLat}
                      tenantLangitude={tenantLng}
                      selectedCountry={tenantCountry}
                      currentCommunityLocation={currentCommunityLocation}
                      zoomLevel={zoomLevel}
                    />
                  </Dialog>
                ) : null}
              </div>
            </div>
          </div>
          <div className={className}>
            <div className="StartCommunity">
              <div className="StartCommunity-Container">
                <div className="StartCommunity-Header">
                  <p className="StartCommunity-Header--Title">
                    {!hasCountryCommunity
                      ? `Start your Community${
                          tenantCountry ? ` in ${tenantCountry}` : ""
                        }`
                      : `Start your Community`}
                  </p>
                  <button
                    className="StartCommunity-Header--Close"
                    onClick={props.close}
                  >
                    <img src={CloseBtn} alt="Close-Button" />
                  </button>
                </div>
                <div className="StartCommunity-Body">
                  <div className="StartCommunity-Info">
                    <span className="indicatorImportant">*</span>&nbsp;Indicates
                    required
                  </div>
                </div>
                <div className="StartCommunity-Body--PersonalForm">
                  <div className="EditInputfeild">
                    <label
                      className="EditName"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      Display Name:<span className="indicatorImportant">*</span>
                      <IconButton
                        style={{ margin: 0, padding: 6 }}
                        onClick={onClickDisplayNameInfo}
                      >
                        <BsInfoCircle fontSize={18} />
                      </IconButton>
                    </label>
                    <input
                      type="text"
                      value={displayName}
                      onChange={(e) => {
                        setDisplayName(e.target.value);
                        setSubmitErrMsg(false);
                      }}
                      minLength={3}
                      maxLength={32}
                      style={{
                        color:
                          signinOrBlocked && hasProfileDisplayName
                            ? "rgba(0, 0, 0, 0.38)"
                            : "",
                      }}
                      disabled={signinOrBlocked && hasProfileDisplayName}
                    />
                  </div>
                  <div className="EmailField">
                    <label className="EditName">
                      Email:<span className="indicatorImportant">*</span>
                    </label>
                    <input
                      type="text"
                      value={emailID}
                      onChange={(e) => {
                        setEmailID(e.target.value);
                        setSubmitErrMsg(false);
                      }}
                      onBlur={handleEmailBlur}
                      style={{
                        color:
                          signinOrBlocked && hasProfileEmail
                            ? "rgba(0, 0, 0, 0.38)"
                            : "",
                      }}
                      disabled={signinOrBlocked && hasProfileEmail}
                      readOnly={signinOrBlocked && hasProfileEmail}
                    />
                  </div>
                  <div className="EditInputfeild">
                    <label className="EditName">
                      First Name:<span className="indicatorImportant">*</span>
                    </label>
                    <input
                      type="text"
                      value={firstname}
                      onChange={(e) => {
                        setFirstname(e.target.value);
                        setSubmitErrMsg(false);
                      }}
                      maxLength={50}
                      style={{
                        color:
                          signinOrBlocked && hasProfileFirstName
                            ? "rgba(0, 0, 0, 0.38)"
                            : "",
                      }}
                      disabled={signinOrBlocked && hasProfileFirstName}
                    />
                  </div>

                  <div className="EditInputfeild">
                    <label className="EditName">
                      Last Name:<span className="indicatorImportant">*</span>
                    </label>
                    <input
                      type="text"
                      value={lastname}
                      onChange={(e) => {
                        setLastname(e.target.value);
                        setSubmitErrMsg(false);
                      }}
                      maxLength={50}
                      style={{
                        color:
                          signinOrBlocked && hasProfileLastName
                            ? "rgba(0, 0, 0, 0.38)"
                            : "",
                      }}
                      disabled={signinOrBlocked && hasProfileLastName}
                    />
                  </div>
                  <div className="EditInputfeild">
                    <label className="EditName">
                      Phone:<span className="indicatorImportant">*</span>{" "}
                    </label>
                    <div className="phone-number-container">
                      <select
                        className="EditSubSelectFeild"
                        value={countryDialCode}
                        onChange={onCountryDialCodeChange}
                        style={{
                          color:
                            signinOrBlocked && hasProfilePhone
                              ? "rgba(0, 0, 0, 0.38)"
                              : "",
                        }}
                        disabled={signinOrBlocked && hasProfilePhone}
                      >
                        <option value="" disabled>
                          Select Country
                        </option>
                        {countryDialCodeData.map((each) => (
                          <option
                            key={each.iso2}
                            value={`${each.dialCode}-${each.iso2}`}
                            className="EditSubSelectFeildOption"
                          >
                            {each.dialCode} ({each.name})
                          </option>
                        ))}
                      </select>
                      <input
                        type="text"
                        className="PhoneTextFeild"
                        // value={phonenum}
                        // value={extractPhoneDetails(phonenum)?.number}
                        value={phonenum}
                        onChange={(e) => {
                          setPhonenum(e.target.value);
                          setSubmitErrMsg(false);
                        }}
                        maxLength={10}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        disabled={signinOrBlocked && hasProfilePhone}
                        style={{
                          color:
                            signinOrBlocked && hasProfilePhone
                              ? "rgba(0, 0, 0, 0.38)"
                              : "",
                        }}
                      />
                    </div>
                  </div>

                  <div className="EditInputfeild">
                    <label className="EditName">
                      Country:<span className="indicatorImportant">*</span>
                    </label>
                    <Select
                      options={countryList.map((ele) => ({
                        label: ele,
                        value: ele,
                      }))}
                      value={{ label: country, value: country }}
                      onChange={(selected) => updateStateList(selected)}
                      styles={selectStyles}
                      isDisabled={signinOrBlocked && hasProfileCountry}
                      style={{
                        color:
                          signinOrBlocked && hasProfileCountry
                            ? "rgba(0, 0, 0, 0.38)"
                            : "",
                      }}
                    />
                  </div>
                  <div className="address-city-input-main-container">
                    <div className="EditInputSubfeild">
                      <label className="EditName">
                        Address:<span className="indicatorImportant">*</span>
                      </label>
                      <input
                        type="text"
                        value={address}
                        onChange={(e) => {
                          setAddress(e.target.value);
                          setSubmitErrMsg(false);
                        }}
                        maxLength={50}
                        style={{
                          color:
                            signinOrBlocked && hasProfileAddress
                              ? "rgba(0, 0, 0, 0.38)"
                              : "",
                        }}
                        disabled={signinOrBlocked && hasProfileAddress}
                      />
                    </div>

                    <div className="EditInputSubfeild">
                      <label className="EditName">
                        City:<span className="indicatorImportant">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        value={city}
                        onChange={(e) => {
                          setCity(e.target.value);
                          setSubmitErrMsg(false);
                        }}
                        maxLength={50}
                        style={{
                          color:
                            signinOrBlocked && hasProfileCity
                              ? "rgba(0, 0, 0, 0.38)"
                              : "",
                        }}
                        disabled={signinOrBlocked && hasProfileCity}
                      />
                    </div>
                  </div>
                  <div className="address-city-input-main-container">
                    <div className="EditInputSubfeild">
                      <label className="EditName">
                        State:<span className="indicatorImportant">*</span>
                      </label>
                      <Select
                        options={
                          statesList
                            ? statesList.map((ele) => ({
                                label: ele,
                                value: ele,
                              }))
                            : []
                        }
                        value={{ label: state, value: state }}
                        style={{
                          color:
                            signinOrBlocked && hasProfileState
                              ? "rgba(0, 0, 0, 0.38)"
                              : "",
                        }}
                        isDisabled={signinOrBlocked && hasProfileState}
                        onChange={(selected) => {
                          setState(selected?.value ?? "");
                          setSubmitErrMsg(false);
                        }}
                        styles={selectStyles}
                      />
                    </div>

                    <div className="EditInputSubfeild">
                      <label className="EditName">
                        Zip Code:<span className="indicatorImportant">*</span>
                      </label>
                      <input
                        type="text"
                        value={zipcode}
                        onChange={(e) => {
                          setZipcode(e.target.value);
                          setSubmitErrMsg(false);
                        }}
                        style={{
                          color:
                            signinOrBlocked && hasProfileZipcode
                              ? "rgba(0, 0, 0, 0.38)"
                              : "",
                        }}
                        disabled={signinOrBlocked && hasProfileZipcode}
                        maxLength={15}
                      />
                    </div>
                  </div>
                </div>
                <div className="StartCommunity-Footer">
                  <div className="CommunityGuidlines">
                    <div className="community-guidLine-checkbox-container">
                      <input
                        type="checkbox"
                        checked={userGuidelineChecked}
                        onChange={(e) => {
                          setUserGuidelineChecked(e.target.checked);
                          setSubmitErrMsg(false);
                        }}
                      />
                      <p>
                        By starting a Community, you are agreeing to Skopic
                        etiquette and{" "}
                        <span>
                          <Link to={"/LoginUserGuidelines"} target="_blank">
                            User Guidelines
                          </Link>
                        </span>
                        <span className="indicatorImportant">*</span>
                      </p>
                    </div>
                    <div className="community-guidLine-checkbox-container">
                      <input
                        type="checkbox"
                        checked={modGuidelineChecked}
                        onChange={(e) => {
                          setModGuidelineChecked(e.target.checked);
                          setSubmitErrMsg(false);
                        }}
                      />
                      <p>
                        By accepting to be a Primary Moderator, you are agreeing
                        to{" "}
                        <span>
                          <Link to={"/ModeratorGuidelines"} target="_blank">
                            Moderator Guidelines
                          </Link>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="SubmitPageContainer">
                    <button
                      onClick={() => {
                        startCommunity(file);
                      }}
                      className={
                        emailRegex.test(emailID) &&
                        displayName?.length >= 3 &&
                        firstname !== "" &&
                        lastname !== "" &&
                        phonenum !== "" &&
                        phonenum?.length === 10 &&
                        address !== "" &&
                        city !== "" &&
                        zipcode !== "" &&
                        state !== "" &&
                        country !== "" &&
                        userGuidelineChecked === true &&
                        modGuidelineChecked === true
                          ? "afterSubmit"
                          : "beforeSubmit"
                      }
                    >
                      Submit
                    </button>
                    <span>2 of 2</span>
                  </div>
                  {submitErrMsg ? (
                    <p id="name" className="StartCommunityErrorMsg">
                      Please enter all details correctly and accept the User and
                      Moderator Guidelines to submit the new community
                    </p>
                  ) : null}
                  <Popup
                    open={submitStatus}
                    modal
                    closeOnDocumentClick={false}
                    overlayStyle={{ zIndex: 1900 }}
                    contentStyle={{
                      borderRadius: "15px",
                      padding: "0px 10px",
                      /* Add any other styles you want to apply */
                    }}
                  >
                    <div className="success-popup">
                      <p>{successMsg}</p>
                      <button
                        className="StartCommunity-Header--Close"
                        onClick={() => {
                          setSubmitStatus(false);
                          props.close();
                        }}
                      >
                        <img src={CloseBtn} alt="Close-Button" />
                      </button>
                    </div>
                  </Popup>

                  <Popup
                    open={emailExistsModal}
                    modal
                    closeOnDocumentClick={false}
                    overlayStyle={{ zIndex: 1900 }}
                    contentStyle={{
                      borderRadius: "15px",
                      padding: "20px",
                      width: "450px",
                      textAlign: "center",
                    }}
                  >
                    <div className="email-exists-popup">
                      <p>
                        You have an account in Skopic, please Sign-in and
                        continue with your request to start a new community
                      </p>
                      <div
                        className="popup-actions"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "1rem",
                        }}
                      >
                        <button
                          className="popup-ok-btn"
                          onClick={() => {
                            setEmailExistsModal(false);
                            if (props.close) {
                              props.close();
                            }
                            window.location.href = "/?goToSignIn=true";
                          }}
                        >
                          Ok
                        </button>
                        <button
                          className="popup-cancel-btn"
                          onClick={() => {
                            setEmailExistsModal(false);
                            // Stay on the same form
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </Popup>
                </div>
              </div>
            </div>
          </div>
          <Popover
            id={displayNameId}
            open={displayNameOpen}
            anchorEl={anchorEl}
            onClose={onHideDisplayNameInfo}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            style={{ zIndex: 1600 }}
          >
            <Typography style={{ padding: "10px", maxWidth: "300px" }}>
              This is how you will be known in public to all Skopic users.
            </Typography>
          </Popover>
        </>
      ) : (
        <div></div>
      )}
    </div>
  );
}
export default StartCommunities;
